module.exports = __webpack_public_path__ + "static/media/Grass.113b700e.png";